import { Tag } from '@ardoq/status-ui';
import { AppliedSettingsRow } from './AppliedSettingsRow';
import { IconName } from '@ardoq/icons';
import { LabelSetting } from './types';
import { t, type I18nLocale } from '@ardoq/i18n';

type Props = {
  settings: LabelSetting;
  i18nLocale: I18nLocale;
};

export const LabelSettingsWithMultiselect = ({
  settings,
  i18nLocale,
}: Props) => {
  const { labelFormatting, onEditClick } = settings;
  const customLabelsCount = labelFormatting.length;

  const tag = (
    <Tag label={customLabelsCount.toString()} key="LabelFormattingTag" />
  );

  return (
    <AppliedSettingsRow
      label={t(i18nLocale, 'appLayout:labelsLabel', 'Labels')}
      tags={[tag]}
      icon={IconName.TAG}
      onEditClick={onEditClick}
      isDisabled={!customLabelsCount}
      i18nLocale={i18nLocale}
    />
  );
};
